import { IResponseData } from '@/core/interfaces/common'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { TransactionResponse } from './OrdersInterface'
import OrdersService from './OrdersService'

interface OrdersState {
  orders: IResponseData<TransactionResponse[]> | null
  order: TransactionResponse | null
}

const initialState: OrdersState = {
  orders: null,
  order: null,
}

export const getOrdersThunk = createAsyncThunk(
  'Orders/getOrdersThunk',
  async (pageSize: number, { rejectWithValue }) => {
    try {
      return await OrdersService.getOrders(pageSize)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const getOrderThunk = createAsyncThunk(
  'Orders/getOrderThunk',
  async (id: string, { rejectWithValue }) => {
    try {
      return await OrdersService.getOrder(id)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const closeOrderThunk = createAsyncThunk(
  'Orders/closeOrderThunk',
  async (id: string, { rejectWithValue }) => {
    try {
      return await OrdersService.getOrder(id)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {},

  extraReducers: builder => {
    builder
      .addCase(getOrdersThunk.fulfilled, (state, action) => {
        state.orders = action.payload
      })
      .addCase(getOrdersThunk.rejected, state => {
        state.orders = null
      })

      .addCase(getOrderThunk.fulfilled, (state, action) => {
        state.order = action.payload
      })
      .addCase(getOrderThunk.rejected, state => {
        state.order = null
      })
  },
})

export const { actions, reducer } = ordersSlice
